import React from "react";
import createSvgIcon from "@material-ui/core/utils/createSvgIcon";

/**
 * author: Austin Andrews
 * id 29792687-63C3-41A6-8182-CF829969BD48
 * name border-bottom-variant
 * version: 2.2.43
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/border-bottom-variant.svg
 * tags
 * - Text / Content / Format 
 */
export const BorderBottomVariantIcon = createSvgIcon(<><path d="M5,15H3V17H5M3,21H21V19H3M5,11H3V13H5M19,9H21V7H19M19,5H21V3H19M5,7H3V9H5M19,17H21V15H19M19,13H21V11H19M17,3H15V5H17M13,3H11V5H13M5,3H3V5H5M9,3H7V5H9" /></>, 'BorderBottomVariantIcon');
export default BorderBottomVariantIcon